import { defineComponent } from '@digitalbranch/app'

// import imageArm32 from '../../assets/arm32emulator.png'

import template from './main.html'
import css from './main.css'

export const main = defineComponent({
  name: 'app-main',
  template,
  css,
  data(): any {
    return {
      imageArm32: '/arm32emulator.0e2a0aa7.png',
      isNavigationOpen: false,
      navigationIcon: 'menu',
      navigationState: null,
    }
  },
  listeners: {


  },
  methods: {
    toggleNavigation() {
      const isOpen = this.isNavigationOpen
      const isOpening = !isOpen

      this.navigationIcon = isOpen ? 'menu' : 'menu_open'
      this.navigationState = isOpening ? 'opening' : 'closing'
    },
    handleAnimationEnd(e: AnimationEvent) {
      const { animationName } = e

      if (animationName === 'navigation-open') {
        this.isNavigationOpen = true
        this.navigationState = null
      }

      else if (animationName === 'navigation-close') {
        this.isNavigationOpen = false
        this.navigationState = null
      }
    }
  },
})
